module.exports = '/ng-templates/features/record/kp-carousel/kp-carousel.tpl.ftl';
